import '@modifi/plugin-documents/register'
import '@modifi/plugin-forms/register'
import '@modifi/plugin-user/register'
import '@modifi/plugin-trade/register'
import {init as i18nInit} from '@modifi/plugin-i18n/register'
import '@modifi/plugin-google-tag-manager/register'

export type PluginFactoryOpts = {
  i18n?: Record<string, any>
} & Record<string, any>

export const initPlugins = (options: PluginFactoryOpts = {}): Promise<void> =>
  Promise.all([i18nInit(options?.i18n)]).then(() => undefined)
